export default {
      id: "icon-oh-oui-usage",
      viewBox: "0 0 109.4 109.4",
      url: __webpack_public_path__ + "icons.svg#icon-oh-oui",
      toString: function () {
        return this.url;
      }
    }